import React from "react";
import Project from "./Project.js";
import projectsData from "../data/projectsData";
import "../styles/Projects.css";

const Projects = () => {
  return (
    <div className="projects">
    <h3>Personal projects</h3>
      <div className="projects-group">
        {projectsData.personalProjects.map(project => {
          return (
            <Project
              key={project.title}
              group="web-app"
              title={project.title}
              description={project.description}
              tools={project.tools}
              demo={project.demo}
              code={project.code}
              img={project.img}
            />
          );
        })}
      </div>
      <h3>PROJECTs @ Humbleschool</h3>
      <div className="projects-group">
        {projectsData.humbleschool.map(project => {
          return (
            <Project
              key={project.title}
              group="web-app"
              title={project.title}
              description={project.description}
              tools={project.tools}
              demo={project.demo}
              code={project.code}
              img={project.img}
            />
          );
        })}
      </div>
      <h3>WEB APPS</h3>
      <div className="projects-group">
        {projectsData.web_apps.map(web_app => {
          return (
            <Project
              key={web_app.title}
              group="web-app"
              title={web_app.title}
              description={web_app.description}
              tools={web_app.tools}
              demo={web_app.demo}
              code={web_app.code}
              img={web_app.img}
            />
          );
        })}
      </div>
      <h3>MINI PROJECTS</h3>
      <div className="projects-group">
        {projectsData.api_microservices.map(api => {
          return (
            <Project
              key={api.title}
              group="mini-projects"
              title={api.title}
              description={api.description}
              tools={api.tools}
              demo={api.demo}
              code={api.code}
              img={api.img}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Projects;



// WEBPACK FOOTER //
// ./src/components/Projects.js